// src/App.js
import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Layout } from "antd";
import "./App.css";

// 引入组件
import HeaderBar from "./components/Header";
import FooterItem from "./components/FooterItem";
import Home from "./pages/Home";
import About from "./pages/About";
import ArchivePage from "./pages/Archive";
import PostDetail from "./pages/PostDetail";
import WritePost from "./pages/WritePost";
import Auth from "./pages/Auth";
import NotFound from "./pages/NotFound";
import Projects from "./pages/Projects";
import SwordTextGen from "./pages/SwordTextGen"; // 添加这行
import { isAuthed } from "./api/mockData";
import BackgroundParticles from "./components/BackgroundParticles";
import DogRecognition from "./pages/DogRecognition";
import LoraFinetuning from "./pages/LoraFinetuning";

// 导入门之钥组件
import DoorKey from "./pages/DoorKey";
import HuskyTracking from "./pages/HuskyTracking";

const { Content, Footer } = Layout;

function RequireAuth({ children }) {
  const loc = useLocation();
  if (!isAuthed()) return <Navigate to="/auth" replace state={{ from: loc.pathname }} />;
  return children;
}

export default function App() {
  useEffect(() => {
    document.body.style.backgroundColor = "transparent";
    console.log("🎯 App组件已加载，准备显示粒子效果");
    
    // 初始化主题
    const savedTheme = localStorage.getItem("blog-theme") || "wuxia";
    document.body.setAttribute("data-theme", savedTheme);
    
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <>
      <BackgroundParticles />

      <Layout className="app-shell" style={{ position: "relative"}}>
        <HeaderBar />
        <Content className="main-wrap">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/post/:id" element={<PostDetail />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/sword-text-gen" element={<SwordTextGen />} /> {/* 添加这行 */}
            <Route
              path="/write"
              element={
                <RequireAuth>
                  <WritePost />
                </RequireAuth>
              }
            />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
            <Route path="/dog-recognition" element={<DogRecognition />} />
            <Route path="/lora-finetuning" element={<LoraFinetuning />} />
            <Route path="/door-key" element={<DoorKey />} />
            <Route path="/husky-tracking" element={<HuskyTracking />} />
          </Routes>
        </Content>
        <Footer style={{ background: "transparent" }}>
          <FooterItem />
        </Footer>
      </Layout>
    </>
  );
}